import React from 'react'
import Layout from '../../Layout/Layout';

import { Link } from "react-router-dom";

const IFF_investment = () => {
  return (
      <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>IIF Investment readiness Program</h2></div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>The project titled Transaction Advisory & Investment
                         Readiness Services to Enterprises was a collaborative engagement between 
                         the Impact Investors Foundation (IIF) and Moolu Ventures to address critical
                          barriers to impact investing in Nigeria. The program provided tailored 
                          transaction advisory services to six selected enterprises, focusing on 
                          key areas such as due diligence, valuation analysis, deal structuring,
                           negotiation support, and pitch deck refinement. 
</p>

                <p className='light'>This comprehensive support was designed to transform businesses
                     into investment-ready entities, ensuring their long-term operational and financial
                      sustainability and enhancing their attractiveness to investors.</p>
               </div>

                <div className='uk-width-1-2@s'>
                 <p className='light'>The structured advisory process began with an in-depth due 
                    diligence review to assess the financial and operational
                     positions of each enterprise, followed by valuation analysis
                      to determine their worth and optimal deal structuring. The 
                      expected outcomes included significant advancements in the
                       enterprises' readiness to attract and engage with investors,
                        leading to enhanced corporate governance, operational
                         efficiency, and strategic clarity.</p>

                         <p className='light'> General learnings from 
                         the program emphasized the importance of a rigorous
                          participant selection process to ensure founders are at 
                          the right business stage and are fully committed to 
                          implementing the complex concepts of investment readiness.</p>

                          <p className='light'>Find link to Program report <Link to="/iff_annual_gathering">IFF Investors readiness report </Link></p>
               </div>
            </div>
        </div>
        </Layout>
  )
}

export default IFF_investment